var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustriesGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 729,
    viewBox: "0 0 484 729",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7655_30911)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M482.998 0.269531V728.752",
    stroke: "url(#paint0_linear_7655_30911)",
    strokeWidth: 0.767352
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 0.269531V728.752",
    stroke: "url(#paint1_linear_7655_30911)",
    strokeWidth: 0.767352
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M322.383 0.269531V728.752",
    stroke: "url(#paint2_linear_7655_30911)",
    strokeWidth: 0.767352
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M161.76 0.269531V728.752",
    stroke: "url(#paint3_linear_7655_30911)",
    strokeWidth: 0.767352
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.14258 146H483",
    stroke: "url(#paint4_linear_7655_30911)",
    strokeWidth: 0.767352
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.14258 292H483",
    stroke: "url(#paint5_linear_7655_30911)",
    strokeWidth: 0.767352
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.14258 438H483",
    stroke: "url(#paint6_linear_7655_30911)",
    strokeWidth: 0.767352
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.14258 584H483",
    stroke: "url(#paint7_linear_7655_30911)",
    strokeWidth: 0.767352
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405457,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405457,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405457,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405457,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7655_30911",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492488,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7655_30911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484,
    height: 729,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustriesGrid);
export default __webpack_public_path__ + "static/media/industries-grid.0d46008a1c0b37ae6146fc5c9c68229f.svg";
export { ForwardRef as ReactComponent };